"use client";

import React, { useState } from "react";
import { Search, X } from "lucide-react";
import { usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { cn } from "@/lib/utils";
export default function SearchFilter() {
  const [inputValue, setInputValue] = useState("");
  const {
    setQuery
  } = usePosts();
  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setQuery({
      s: inputValue,
      paged: 1
    });
  };
  const handleClear = () => {
    setInputValue("");
    setQuery({
      s: "",
      paged: 1
    });
  };
  return <form onSubmit={handleSearch} className="relative group w-full">
      {/* 左側放大鏡圖標區域 */}
      <div className="absolute inset-y-0 left-5 flex items-center pointer-events-none">
        {/*  核心修改 1：放大鏡顏色全面鎖定為 #7a6a59，免除主題色干擾 */}
        <Search className="size-5 text-[#7a6a59] transition-colors" />
      </div>
      
      {/* 搜尋欄輸入框本體 */}
      <input type="text" value={inputValue} placeholder="搜尋地板保養、施工知識或選購指南..." onChange={e => setInputValue(e.target.value)} className="w-full h-16 pl-14 pr-32 bg-[#f0e7e0] border border-[#7a6a59] rounded-full text-lg text-[#3d3d3d] focus:outline-none focus:ring-1 focus:ring-[#7a6a59] focus:border-[#7a6a59] transition-all placeholder:text-[#7a6a59]/50 font-hk-light" />

      {/* 右側按鈕與清除鍵控制區 */}
      <div className="absolute inset-y-0 right-3 flex items-center gap-2">
        {inputValue && <button type="button" onClick={handleClear} className="p-2 text-[#7a6a59]/60 hover:text-[#7a6a59] transition-colors">
            <X className="size-5" />
          </button>}
        
        {/* 搜尋提交按鈕 */}
        {/*  核心修改 3：
            - bg-[#7a6a59]：搜尋按鈕底色完美套用
            - hover:bg-[#68594a]：滑鼠懸停時自然轉為深一度的大地色，反饋非常細緻
         */}
        <button type="submit" className="bg-[#7a6a59] text-white px-7 py-2.5 rounded-full text-sm font-hk-regular tracking-widest hover:bg-[#68594a] transition-all shadow-sm active:scale-95 cursor-pointer">
          搜尋
        </button>
      </div>
    </form>;
}